/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormCheck,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { useDispatch } from "react-redux";
import { addInterval } from "../../../redux/actions/calenderActions";
import { getSession } from "../../../redux/actions/authActions";

const NewCalender = ({
  show,
  selectedTitle,
  onHide,
  selectedId,
  slots,
  loading,
}) => {
  const dispatch = useDispatch();

  const { role_id, user_profile_id } = getSession();
  const [selectedDate, setSelectedDate] = useState("");
  const intervalsArray = [
    { ID: "svc_cal_01", label: "00:00 to 01:00" },
    { ID: "svc_cal_02", label: "01:00 to 02:00" },
    { ID: "svc_cal_03", label: "02:00 to 03:00" },
    { ID: "svc_cal_04", label: "03:00 to 04:00" },
    { ID: "svc_cal_05", label: "04:00 to 05:00" },
    { ID: "svc_cal_06", label: "05:00 to 06:00" },
    { ID: "svc_cal_07", label: "06:00 to 07:00" },
    { ID: "svc_cal_08", label: "07:00 to 08:00" },
    { ID: "svc_cal_09", label: "08:00 to 09:00" },
    { ID: "svc_cal_10", label: "09:00 to 10:00" },
    { ID: "svc_cal_11", label: "10:00 to 11:00" },
    { ID: "svc_cal_12", label: "11:00 to 12:00" },
    { ID: "svc_cal_13", label: "12:00 to 13:00" },
    { ID: "svc_cal_14", label: "13:00 to 14:00" },
    { ID: "svc_cal_15", label: "14:00 to 15:00" },
    { ID: "svc_cal_16", label: "15:00 to 16:00" },
    { ID: "svc_cal_17", label: "16:00 to 17:00" },
    { ID: "svc_cal_18", label: "17:00 to 18:00" },
    { ID: "svc_cal_19", label: "18:00 to 19:00" },
    { ID: "svc_cal_20", label: "19:00 to 20:00" },
    { ID: "svc_cal_21", label: "20:00 to 21:00" },
    { ID: "svc_cal_22", label: "21:00 to 22:00" },
    { ID: "svc_cal_23", label: "22:00 to 23:00" },
    { ID: "svc_cal_24", label: "23:00 to 24:00" },
  ];
  useEffect(() => {
    updateCheckboxState();
  }, [slots]);

  const [checkboxes, setCheckboxes] = useState([]);

  useEffect(() => {
    updateCheckboxState();
  }, []);

  const updateCheckboxState = () => {
    const apiResponse = {
      svc_cal_01: slots.svc_cal_01,
      svc_cal_02: slots.svc_cal_02,
      svc_cal_03: slots.svc_cal_03,
      svc_cal_04: slots.svc_cal_04,
      svc_cal_05: slots.svc_cal_05,
      svc_cal_06: slots.svc_cal_06,
      svc_cal_07: slots.svc_cal_07,
      svc_cal_08: slots.svc_cal_08,
      svc_cal_09: slots.svc_cal_09,
      svc_cal_10: slots.svc_cal_10,
      svc_cal_11: slots.svc_cal_11,
      svc_cal_12: slots.svc_cal_12,
      svc_cal_13: slots.svc_cal_13,
      svc_cal_14: slots.svc_cal_14,
      svc_cal_15: slots.svc_cal_15,
      svc_cal_16: slots.svc_cal_16,
      svc_cal_17: slots.svc_cal_17,
      svc_cal_18: slots.svc_cal_18,
      svc_cal_19: slots.svc_cal_19,
      svc_cal_20: slots.svc_cal_20,
      svc_cal_21: slots.svc_cal_21,
      svc_cal_22: slots.svc_cal_22,
      svc_cal_23: slots.svc_cal_23,
      svc_cal_24: slots.svc_cal_24,
    };

    const updatedCheckboxes = intervalsArray.map((interval) => ({
      ...interval,
      isChecked: apiResponse[interval.ID] === "Y",
    }));

    setCheckboxes(updatedCheckboxes);
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const handleCheckboxChange = (id) => {
    setCheckboxes((prevCheckboxes) =>
      prevCheckboxes.map((checkbox) =>
        checkbox.ID === id
          ? { ...checkbox, isChecked: !checkbox.isChecked }
          : checkbox
      )
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const checkedValues = {
      svcf_id: selectedId,
      sys_user_id: user_profile_id,
      role_id: role_id,
      svc_cal_id: slots.svc_cal_id,
    };
    checkboxes.forEach((checkbox) => {
      checkedValues[checkbox.ID] = checkbox.isChecked ? "Y" : "N";
    });
    dispatch(addInterval(checkedValues));
    onHide();
  };

  return (
    <Modal
      className="edit_modal profile"
      show={show}
      onHide={onHide}
      centered
      centeredSign
      Out
    >
      <Modal.Header closeButton>
        <h5 className="mb-0">{`Calendar`}</h5>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col lg={6}>
              <h5>{selectedTitle}</h5>
            </Col>{" "}
            <Col lg={6}>
              <div
                className="mb-3"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Form.Control
                  type="date"
                  value={selectedDate}
                  onChange={(e) => {
                    const dateValue = e.target.value;
                    setSelectedDate(dateValue);
                    handleDateChange(dateValue);
                  }}
                />
              </div>
            </Col>
          </Row>

          <Row className="mb-3">
            {loading ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Spinner variant="primary" />
              </div>
            ) : (
              checkboxes.map((checkbox) => (
                <Col lg={4} md={4} sm={6} xs={6} key={checkbox.ID}>
                  <FormCheck
                    type="checkbox"
                    label={checkbox.label}
                    checked={checkbox.isChecked}
                    onChange={() => handleCheckboxChange(checkbox.ID)}
                  />
                </Col>
              ))
            )}
          </Row>
          <Row>
            <Col>
              {role_id === "3" ? (
                ""
              ) : (
                <div className="mini_edit flex justify-center">
                  <Button
                    className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm"
                    variant="secondary"
                    onClick={onHide}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="w-full !rounded-md !max-w-28 !text-sm !bg-primary-blue h-[43px] !border-primary-blue"
                    variant="primary"
                    type="submit"
                  >
                    Save
                  </Button>
                </div>
              )}
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export { NewCalender };
